import React, { Component } from 'react';
import { escapeRegexCharacters } from './utils';

export class SearchProduct extends Component {
    displayName = SearchProduct.name;

    constructor(props) {
        super(props);

        this.state = {
            nwsOnly: false,
            value: "",
            previousValue: "",
            searchItems: []
        };
    }

    onNWSCheck = () => {
        var flag = this.state.nwsOnly;
        this.setState({ nwsOnly: !flag });
    }

    searchProduct = (evt) => {
        var value = this.state.value;

        this.setState({ previousValue: value });

        if(this.props.searchHidden)
            this.props.hideSearch();

        const escapedValue = escapeRegexCharacters(value.trim());
        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'cache': false
            }
        };

        fetch(`api/OrderGuide/Products/?isNWS=${this.props.isNWS}&lhPattern=${escapedValue}&orderGuideId=${this.props.orderGuideId}`, fetchConfig)
            .then(response => {
                if (response.ok) {
                    response.json()
                        .then(data => {
                            this.setState({ searchItems: data });
                        })
                        .catch(e => {
                            console.log("unable to parse json response in onSuggestionsFetchRequested");
                        });
                }
                //else {
                //    this.setState({ responseStatus: response.status });
                //}
            })
            .catch(error => {
                console.log("error in onSuggestionsFetchRequested");
                console.log(error);
            });

    }

    add = (item, idx) => {
        this.props.addItemToGuide(item);

        const rows = [...this.state.searchItems];
        rows.splice(idx, 1);
        this.setState({ searchItems: rows });
    }

    clear = () => {
        this.props.hideSearch();
    }

    isEnter(event) {
        if (event.keyCode === 13) {
            this.searchProduct(event);
        }
    }

    render() {
        return (
            <React.Fragment>
                <div style={{width: '100%'}}>
                    <div>
                        <div style={{display:'inline-block'}}>
                            <input type="text" value={this.state.value} onChange={(e) => { this.setState({ value: e.target.value }); }} onKeyUp={(e) => this.isEnter(e)} placeholder="Search Product" />
                            <input className="ogcButton" type="button" value="Search" onClick={(e) => this.searchProduct(e)} />
                        </div>
                    </div>
                    <div className="tableFixHead" style={{ height: (this.props.searchHidden) ? '0vh' : '20vh', overflowY: 'auto', visibility: (this.props.searchHidden) ? 'hidden' : ''  }}>
                        <table className="table table-hover" id="tab_logic">
                            <thead>
                                <tr>
                                    <th>Description</th>
                                    <th>OGC Product Id</th>
                                    <th>Short Code</th>
                                    <th>Brand</th>
                                    <th>Stock</th>
                                    <th>Incoming</th>
                                    <th>Add</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.searchItems.map((searchItem, idx) =>
                                    (<tr key={searchItem.productId}>
                                        <td>{searchItem.description}</td>
                                        <td>{searchItem.ogcProductID}</td>
                                        <td>{searchItem.productSKU}</td>
                                        <td>{searchItem.brand}</td>
                                        <td>{searchItem.qtyInvToday}</td>
                                        <td>{searchItem.expectedToday}</td>
                                        <td><input type="button" value="+" onClick={(e) => { this.add(searchItem,idx); }} /></td>
                                    </tr>)
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/OrderGuide/AddProduct/SearchProduct.js